import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService, Message } from 'primeng/api';
import { AuthService } from '@auth0/auth0-angular';
import {LoginService} from './login.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css'],
    providers: [MessageService]
})
export class LoginComponent implements OnInit, OnDestroy {
    msgs: Message[] = [];
    showSpinner = false;
    showToggle = false;
    errorMessage: string;
    accessToken: string | null = null;
    idToken: string | null = null;

    constructor(
        private router: Router,
        private messageService: MessageService,
        private loginService: LoginService,
        public auth: AuthService
    ) { }

    ngOnInit() {
        const body = document.getElementsByTagName('body')[0];
        body.classList.add('login');

        // Check if the user is authenticated
        this.auth.user$.subscribe(async user => {
            if (user) {  
                try {
                    // Start OpenReplay only after sign-in
                    (window as any).startOpenReplay?.();
                } catch {}
                try {
                    const email = (user as any)?.email;
                    if (email && (window as any).tracker?.setUserID) {
                        (window as any).tracker.setUserID(email);
                    }
                } catch {}
                this.auth.getAccessTokenSilently().subscribe(
                    (token) => {
                        localStorage.setItem('bearerToken', `Bearer ${token}`);
                        this.showSpinner = true;
                        this.getPostLoginData();
                        //this.router.navigate(['/dashboard']);
                    },
                    (error) => {
                        console.error('Access Token Error:', error);
                        
                    }
                );
                
            } else {
                this.loginWithAuth0();
            }
        });

        // Handle Auth0 authentication error
        this.auth.error$.subscribe(error => {
            this.errorMessage = error.message;
            this.showToggle = true;
            this.showSpinner = false;
        });
    }

    ngOnDestroy(): void {
        const body = document.getElementsByTagName('body')[0];
        body.classList.remove('login');
    }

    getPostLoginData() {
        this.loginService.getPostLoginData().subscribe(res => {
            localStorage.setItem('loginId', res.data.id);
            localStorage.setItem('loginReportId', res.data.loginReportId);
            localStorage.setItem('type', res.data.type);
            localStorage.setItem('defaultLandingPage', res.data.defaultLandingPage);
            window.localStorage.setItem('loggedIn', 'true');
            this.loginService.userLoggedIn.emit();
            (window as any).loggedInUser = res.data;
            if(res.success && res.data.defaultLandingPage == 'dashboard'){
                this.router.navigate(['/dashboard']);
            }
            else{
                if (res.data.type == 'c') {
                    this.router.navigate(['/clienthome']);
                } else {
                    this.router.navigate(['/home']);
                }    
            }
            this.showSpinner = false;
        }, error => {
            this.showSpinner = false;
            // on error log out
            localStorage.clear();
            this.auth.logout({ logoutParams: { returnTo: document.location.origin }} as any);
        });
    }

    loginWithAuth0() {
        this.showSpinner = true;
        this.auth.loginWithRedirect();
    }

    closeErrorDiv() {
        this.showToggle = !this.showToggle;
    }

    showSuccess(message: string) {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: message });
    }

    showError(message: string) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
    }
}